var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-popup',{style:(_vm.inLineStyle),attrs:{"get-container":"body"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('div',{staticClass:"header"},[_vm._t("header")],2),_c('div',{staticClass:"content"},[_vm._t("content")],2),_c('div',{staticClass:"footer"},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }